import React, { useState } from 'react';
import { SimpleForm } from 'react-admin';
import { makeStyles } from '@mui/styles';

import { Credit } from '@types';
import { InitialPage } from '@components';
import { FieldReport } from '@pages/cx/Components/FieldReport';
import { PolicyInsurances } from '@pages/cx/Components/Insurance/PolicyInsurances';

interface Props {
  setCredit?: (newCredit: Credit) => void;
  credit: Credit;
  editable?: boolean;
}

export const CreditFarmsPage = ({ credit, editable }: Props) => {
  const backTo = `/credit/${credit.id}`;
  const [hasUpdated, setHasUpdated] = useState<boolean>(false);
  const cls = useStyles();

  return (
    <InitialPage title="Farms and Insurance" backTo={backTo} backText="Back to credit">
      <SimpleForm toolbar={false} defaultValues={credit}>
        <div className={cls.container}>
          <FieldReport
            credit={credit}
            editable={editable}
            hasUpdated={hasUpdated}
            setHasUpdated={setHasUpdated}
            showMap
          />
        </div>
      </SimpleForm>

      <PolicyInsurances credit={credit} editable={editable} shortEdit />
    </InitialPage>
  );
};

const useStyles = makeStyles({
  container: {
    paddingTop: 20,
    marginBottom: 20,
    width: '100%',
  },
});
